import LOGO from "Content/images/logo/HunterLogoFull.svg";
import classNames from "classnames";
import compact from "lodash/compact";
import join from "lodash/join";
import React, { useEffect, useState } from "react";
export default function Brand(props) {
    const [logoAlt, setLogoAlt] = useState("");
    useEffect(() => {
        const wrapper = document.querySelector("#content");
        const nameParts = compact([
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.getAttribute("data-companyName"),
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.getAttribute("data-productName")
        ]);
        nameParts.length && setLogoAlt(join(nameParts, ". "));
    }, []);
    return (React.createElement("div", { className: classNames("text-center", props.className), style: props.style },
        React.createElement("img", { alt: logoAlt, src: LOGO, width: 250 })));
}
